(function () {
  const currentScript = document.currentScript;
  const sectionId = currentScript?.dataset.sectionId;
  const lensUiSrc = currentScript?.dataset.lensUiSrc;

  if (!sectionId) return;
function initOcPrescriptionSection() {
  const section = document.getElementById(
    'SunglassesProduct-' + sectionId
  );
  const openBtn = document.getElementById(
    'OcRxOpen-' + sectionId
  );
  const modal = document.getElementById(
    'OcRxModal-' + sectionId
  );
  const holder = document.getElementById(
    'OcRxAppHolder-' + sectionId
  );
  const saveBtn = document.getElementById(
    'OcRxSave-' + sectionId
  );
  const status = document.getElementById(
  'OcRxStatus-' + sectionId
);

if (!section || !openBtn || !modal || !holder) {
  return;
}

/*
 * Connect the complete prescription modal to the real
 * Shopify Add to Cart form.
 *
 * The modal remains visually fixed as a popup, but all
 * Relentless Apps fields now belong to the product form.
 */
const productForm =
  document.getElementById(
    'product-form-' + sectionId
  ) ||
  section.querySelector(
    'form[action*="/cart/add"]'
  );

if (!productForm) {
  return;
}

/*
 * Required so prescription file uploads are included
 * when the product is submitted.
 */
productForm.setAttribute(
  'enctype',
  'multipart/form-data'
);

/*
 * Move the entire modal—not the old app interface—
 * inside the actual Shopify product form.
 */
if (!productForm.contains(modal)) {
  productForm.appendChild(modal);
}
/* Prevent duplicate event listeners on the same section instance */
if (section.dataset.ocRxInitialized === 'true') {
  return;
}

section.dataset.ocRxInitialized = 'true';

let appMoved = false;
let lensUiPromise = null;

function loadLensUI() {
  if (!lensUiSrc) {
    return Promise.resolve();
  }

  if (
    section.dataset.ocLensUiLoaded === 'true'
  ) {
    return Promise.resolve();
  }

  if (lensUiPromise) {
    return lensUiPromise;
  }

  lensUiPromise = new Promise(
    function (resolve, reject) {
      const script =
        document.createElement('script');

      script.src = lensUiSrc;
      script.dataset.sectionId = sectionId;
      script.async = true;

      script.onload = function () {
        section.dataset.ocLensUiLoaded =
          'true';

        resolve();
      };

      script.onerror = function () {
        lensUiPromise = null;

        reject(
          new Error(
            'Failed to load prescription lens UI'
          )
        );
      };

      document.head.appendChild(script);
    }
  );

  return lensUiPromise;
}

  function buildLuxuryUpload(uploadBlock, fileInput) {
    if (!uploadBlock || !fileInput) return;

    if (uploadBlock.dataset.luxuryUploadBuilt === 'true') {
      return;
    }

    uploadBlock.dataset.luxuryUploadBuilt = 'true';
    uploadBlock.classList.add('oc-upload-section');

    

    fileInput.classList.add('oc-upload-input');
    fileInput.setAttribute(
      'aria-label',
      'Browse prescription files'
    );
    fileInput.setAttribute(
      'accept',
      '.jpg,.jpeg,.png,.pdf,image/jpeg,image/png,application/pdf'
    );

    const uploadUI = document.createElement('div');
    uploadUI.className = 'oc-luxury-upload';

    uploadUI.innerHTML = `
      <div class="oc-upload-icon" aria-hidden="true">
        <svg
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 15V4"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
          />
          <path
            d="M7.5 8.5L12 4L16.5 8.5"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M5 14.5V18C5 19.1 5.9 20 7 20H17C18.1 20 19 19.1 19 18V14.5"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
          />
        </svg>
      </div>

      <h3 class="oc-upload-heading">
  Upload your Prescription
</h3>

      <button
        type="button"
        class="oc-upload-button"
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M3.5 6.5H9L10.7 8.3H20.5V18.5C20.5 19.33 19.83 20 19 20H5C4.17 20 3.5 19.33 3.5 18.5V6.5Z"
            stroke="currentColor"
            stroke-width="1.6"
            stroke-linejoin="round"
          />
          <path
            d="M3.5 10H20.5"
            stroke="currentColor"
            stroke-width="1.6"
          />
        </svg>

        <span>Browse Files</span>
      </button>

      <div class="oc-upload-file-name"></div>

      <div class="oc-upload-security-row">
        <span class="oc-upload-security-line"></span>

        <svg
          class="oc-upload-lock"
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <rect
            x="6.5"
            y="10"
            width="11"
            height="9"
            rx="2"
            stroke="currentColor"
            stroke-width="1.5"
          />
          <path
            d="M9 10V7.5C9 5.84 10.34 4.5 12 4.5C13.66 4.5 15 5.84 15 7.5V10"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          />
        </svg>

        <span class="oc-upload-security-line"></span>
      </div>

      <p class="oc-upload-formats">
        JPG, PNG, PDF up to 10MB
      </p>

      <div class="oc-upload-private">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M12 3.5L19 6.2V11.5C19 15.8 16.2 19.3 12 21C7.8 19.3 5 15.8 5 11.5V6.2L12 3.5Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linejoin="round"
          />
          <path
            d="M9 12L11 14L15 10"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <span>Your data is private and secure</span>
      </div>
    `;

    uploadBlock.appendChild(uploadUI);
    uploadUI.appendChild(fileInput);

    const browseButton =
      uploadUI.querySelector('.oc-upload-button');

    const browseButtonText =
      browseButton.querySelector('span');

    const fileNameDisplay =
      uploadUI.querySelector('.oc-upload-file-name');

    function updateSelectedFile() {
      if (
        fileInput.files &&
        fileInput.files.length > 0
      ) {
        uploadUI.classList.add('has-file');

        fileNameDisplay.textContent =
          fileInput.files[0].name;

        browseButtonText.textContent =
          'Change File';
      } else {
        uploadUI.classList.remove('has-file');

        fileNameDisplay.textContent = '';

        browseButtonText.textContent =
          'Browse Files';
      }
    }

    browseButton.addEventListener('click', function () {
      fileInput.click();
    });

    fileInput.addEventListener(
      'change',
      updateSelectedFile
    );

    
  }




  function findAndMoveApp() {
  if (appMoved) return true;

 const originalAppBlock = section.querySelector(
  '.oc-rx-original-app-block'
);

const appForm =
  originalAppBlock?.querySelector('#bcpo') ||
  section.querySelector('#bcpo');

  if (!appForm) return false;

  holder.appendChild(appForm);

const fileInput =
  appForm.querySelector('input[type="file"]');

  if (fileInput) {
    const uploadBlock =
      fileInput.closest('.selector-wrapper') ||
      fileInput.closest('.bcpo-file');

    const firstOptionBlock =
      appForm.querySelector('.selector-wrapper');

    if (uploadBlock) {
      buildLuxuryUpload(
        uploadBlock,
        fileInput
      );
    }

    if (
      uploadBlock &&
      firstOptionBlock &&
      uploadBlock !== firstOptionBlock
    ) {
      appForm.insertBefore(
        uploadBlock,
        firstOptionBlock
      );
    }
  }

  /* Identify and style manual prescription sections */
  function setupManualPrescriptionSections() {
    const optionBlocks =
      appForm.querySelectorAll('.selector-wrapper');

    let firstManualBlock = null;

    optionBlocks.forEach(function (block) {
      const titleElement =
        block.querySelector('.bcpo-title');

      if (!titleElement) return;

      const title = titleElement.textContent
        .replace(/:/g, '')
        .trim()
        .toLowerCase();

      const isRightEye =
        title.includes('prescription') &&
        title.includes('right');

      const isLeftEye =
        title.includes('prescription') &&
        title.includes('left');

      if (!isRightEye && !isLeftEye) return;

      block.classList.add('oc-manual-eye-card');

      if (isRightEye) {
        block.classList.add('oc-right-eye-card');

        titleElement.innerHTML = `
          <span class="oc-eye-title-main">
            Right Eye
          </span>

          <span class="oc-eye-title-code">
            OD
          </span>

          <span class="oc-eye-title-optional">
            Optional
          </span>
          <p class="oc-eye-subtitle">
Enter values exactly as shown on your prescription.
</p>
        `;
      }

      if (isLeftEye) {
        block.classList.add('oc-left-eye-card');

        titleElement.innerHTML = `
          <span class="oc-eye-title-main">
            Left Eye
          </span>

          <span class="oc-eye-title-code">
            OS
          </span>

          <span class="oc-eye-title-optional">
            Optional
          </span>
          <p class="oc-eye-subtitle">
Enter values exactly as shown on your prescription.
</p>
        `;
      }

      if (!firstManualBlock) {
        firstManualBlock = block;
      }
    });

    if (
      firstManualBlock &&
      !appForm.querySelector('.oc-manual-entry-intro')
    ) {
      const intro =
        document.createElement('div');

      intro.className =
        'oc-manual-entry-intro';

      intro.innerHTML = `
        <div class="oc-manual-divider">
          <span></span>
          <strong>OR</strong>
          <span></span>
        </div>

        <p class="oc-manual-eyebrow">
          Enter Manually
        </p>

        <h3 class="oc-manual-title">
          Prescription Details
        </h3>

        <p class="oc-manual-description">
          Enter the values shown on your prescription for each eye.
        </p>
      `;

      firstManualBlock.parentNode.insertBefore(
        intro,
        firstManualBlock
      );
    }
  }

 setupManualPrescriptionSections();

appMoved = true;

return true;
}

async function openModal(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  findAndMoveApp();

  try {
    await loadLensUI();
  } catch (error) {
    console.error(
      'OC prescription lens UI failed to load:',
      error
    );
  }

  modal.classList.add('is-open');

  modal.setAttribute(
    'aria-hidden',
    'false'
  );

  document.body.classList.add(
    'oc-rx-lock'
  );
}

  function closeModal(event) {
    if (event) {
      event.preventDefault();
    }

    modal.classList.remove('is-open');
    modal.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
  'oc-rx-lock'
);

openBtn.focus();
  }

  openBtn.addEventListener(
    'click',
    openModal
  );

  modal
    .querySelectorAll('[data-oc-rx-close]')
    .forEach(function (element) {
      element.addEventListener(
        'click',
        closeModal
      );
    });


document.addEventListener('keydown', function (event) {
  if (
    event.key === 'Escape' &&
    modal.classList.contains('is-open')
  ) {
    closeModal(event);
  }
});

  if (saveBtn) {
    saveBtn.addEventListener('click', function () {
      if (status) {
        status.hidden = false;
        status.textContent = 'Prescription lens details saved';
      }

      closeModal();
    });
  }

if (!findAndMoveApp()) {
  const appBlockForWatch =
    section.querySelector(
      '.oc-rx-original-app-block'
    );

  const appWatchRoot =
    appBlockForWatch || section;

  const appObserver =
    new MutationObserver(function () {
      if (findAndMoveApp()) {
        appObserver.disconnect();
      }
    });

  appObserver.observe(appWatchRoot, {
    childList: true,
    subtree: true
  });

  /*
   * Safety fallback:
   * stop watching after 10 seconds
   * and make one final attempt.
   */
  setTimeout(function () {
    appObserver.disconnect();
    findAndMoveApp();
  }, 10000);
}

} // <-- ADD THIS

/* Normal storefront page load */
if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initOcPrescriptionSection
  );
} else {
  initOcPrescriptionSection();
}

/* Shopify Theme Editor section reload */
document.addEventListener(
  'shopify:section:load',
  function (event) {
    const loadedSection = event.target;

    const sectionDomId =
  'SunglassesProduct-' + sectionId;

if (
  loadedSection &&
  (
    loadedSection.id === sectionDomId ||
    loadedSection.querySelector(
      '#' + CSS.escape(sectionDomId)
    )
  )
) {
  initOcPrescriptionSection();
}
  }
);
})();